import { render, staticRenderFns } from "./PRS0000001SubFooter.vue?vue&type=template&id=27eb40d6&scoped=true&lang=pug&"
import script from "./PRS0000001SubFooter.vue?vue&type=script&lang=ts&"
export * from "./PRS0000001SubFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PRS0000001SubFooter.vue?vue&type=style&index=0&id=27eb40d6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb40d6",
  null
  
)

export default component.exports